export default __webpack_public_path__ + "static/media/GeraldandWine.a1b7d73f.jpg";